import { Sparkle } from "lucide-react";

const ITEMS = [
  "NEW EPISODES EVERY WEEK ON YOUTUBE",
  "BUBZ+ COMING SOON — WWW.BUBZPLUS.COM",
  "CREATED BY J.J. STONE",
  "2-MINUTE ADVENTURES FOR LITTLE DREAMERS",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="relative z-20 -rotate-1 overflow-hidden border-y-4 border-bubz-ink bg-bubz-sun py-3.5"
    >
      <div className="marquee-track flex w-max items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center gap-10 whitespace-nowrap font-display text-base font-semibold uppercase tracking-wide text-bubz-ink"
              >
                {item}
                <Sparkle size={16} className="text-bubz-pink" fill="currentColor" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
